@if (!!item) {
  <svg height="100%" width="100%" viewBox="-24.7 8 249.4 304" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient [attr.id]="'gf-steel-' + item.id" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#b7bdc6"/>
        <stop offset="0.5" stop-color="#eef1f4"/>
        <stop offset="1" stop-color="#a7adb7"/>
      </linearGradient>
      <clipPath [attr.id]="'gf-clip-' + item.id">
        <rect x="72" y="74" width="56" height="116"/>
        <polygon points="72,190 128,190 108,256 92,256"/>
      </clipPath>
    </defs>

    <!-- Tripod stand -->
    <g fill="#3a3d44">
      <polygon points="84,198 90,198 66,304 56,304"/>
      <polygon points="116,198 110,198 134,304 144,304"/>
      <polygon points="96,240 104,240 106,304 94,304"/>
    </g>

    <!-- Liquid fill (clipped to the vessel interior) -->
    <rect [attr.clip-path]="'url(#gf-clip-' + item.id + ')'"
      x="72" [attr.y]="y" [attr.height]="height" width="56"
      [attr.fill]="item.color || item.beverage?.color || '#d99a2b'"/>

    <!-- Stainless conical section (semi-transparent so the level reads) -->
    <polygon points="71,189 129,189 109,257 91,257"
      [attr.fill]="'url(#gf-steel-' + item.id + ')'" fill-opacity="0.42"
      stroke="#7f8790" stroke-width="1.5"/>

    <!-- Stainless upper body (semi-transparent so the level reads through) -->
    <rect x="70" y="72" width="60" height="119" rx="8"
      [attr.fill]="'url(#gf-steel-' + item.id + ')'" fill-opacity="0.42" stroke="#7f8790" stroke-width="1.5"/>

    <!-- Logo badge -->
    <rect x="80" y="118" width="40" height="15" rx="3" fill="#f4efed" stroke="#c9c4c1"/>
    <text x="100" y="129" text-anchor="middle" font-size="5" font-weight="700"
      letter-spacing="0.2" fill="#2a2a2a">GRAINFATHER</text>

    <!-- Digital controller on the cone -->
    <rect x="88" y="203" width="24" height="15" rx="2" fill="#0f2236" stroke="#5b636e"/>
    <rect x="90" y="206" width="14" height="9" rx="1" fill="#1f6f8b"/>
    <circle cx="108" cy="208" r="1.2" fill="#8fd6e6"/>
    <circle cx="108" cy="214" r="1.2" fill="#8fd6e6"/>

    <!-- Domed stainless lid + clamps + collar -->
    <ellipse cx="100" cy="66" rx="38" ry="9" [attr.fill]="'url(#gf-steel-' + item.id + ')'" stroke="#7f8790" stroke-width="1.5"/>
    <path d="M64 66 C64 44 136 44 136 66 Z" [attr.fill]="'url(#gf-steel-' + item.id + ')'" stroke="#7f8790" stroke-width="1.5"/>
    <rect x="94" y="32" width="12" height="8" rx="3" fill="#c9ced6" stroke="#7f8790"/>
    <!-- clamps -->
    <g fill="#4a4d54" stroke="#2c2e33" stroke-width="1">
      <rect x="58" y="58" width="8" height="16" rx="2"/>
      <rect x="134" y="58" width="8" height="16" rx="2"/>
    </g>

    <!-- Dump valve + red handle -->
    <rect x="95" y="256" width="10" height="9" fill="#c9ced6" stroke="#7f8790"/>
    <rect x="92" y="265" width="16" height="5" rx="2" fill="#9aa0a8" stroke="#6f767f"/>
    <rect x="97" y="270" width="6" height="11" fill="#7f8790"/>
    <rect x="88" y="267" width="12" height="4" rx="2" fill="#e23b3b"/>

    <!-- Crisp outer silhouette (steel) -->
    <path d="M70 80 L70 190 L91 257 M130 80 L130 190 L109 257"
      fill="none" stroke="#7f8790" stroke-width="1.2" stroke-linejoin="round" opacity="0.7"/>
  </svg>
}
